import { Box, Container, OldText } from '@gassan-ui'
import { useTranslation } from 'next-i18next'
import { rem } from 'polished'
import { FC } from 'react'

const icons = {
  languages: ['/images/globe_mobile.svg', '/images/globe_desktop.svg'],
  booking: ['/images/calendar_mobile.svg', '/images/calendar_desktop.svg'],
  wifi: ['/images/wifi_mobile.svg', '/images/wifi_desktop.svg'],
  wheelchair: ['/images/wheelchair_mobile.svg', '/images/wheelchair_desktop.svg'],
}

const Usps: FC = () => {
  const { t } = useTranslation('tours')
  return (
    <Container
      maxWidth={rem(865)}
      display={['grid', 'flex']}
      gridTemplateColumns="1fr 1fr"
      gridRowGap="3rem"
      justifyItems="center"
      justifyContent="space-between"
      my={{ _: '3.5rem', xlarge: '5rem' }}
    >
      {Object.keys(icons).map((icon, key) => (
        <Box key={key} maxWidth="8rem" textAlign="center">
          <Box display={['block', 'none']}>
            <img src={icons[icon][0]} alt={icon} />
          </Box>
          <Box display={['none', 'block']}>
            <img src={icons[icon][1]} alt={icon} />
          </Box>
          <OldText variant="small" mb="0.25rem" mt="0.5rem">
            {t(`usps.${icon}.title`)}
          </OldText>
          <OldText variant="micro" color="shades.500" mb="0">
            {t(`usps.${icon}.subtitle`)}
          </OldText>
        </Box>
      ))}
    </Container>
  )
}

export default Usps
